// Relatório em PDF de uma ficha do motor de fichas (saúde, veículos, família, professor, obras — 0.65).
// Usa o mesmo gerador dos outros PDFs (lib/pdf) e entra no menu ⋮ da ficha pela "acoes" da coleção.
import { Alert } from 'react-native';
import { semBloqueio } from '../auth/AuthContext';
import { gerarECompartilharPdf, type BlocoPdf } from './pdf';
import { t } from './i18n';
import type { Action } from '../components/ui';

/** Item "📄 Relatório em PDF" do menu: monta os blocos na hora e compartilha. */
export const acaoRelatorioPdf = (gerar: () => { nome: string; blocos: BlocoPdf[] }): Action => ({
  label: '📄 ' + t('Relatório em PDF'),
  onPress: () => {
    semBloqueio(async () => { const x = gerar(); await gerarECompartilharPdf(x.nome, x.blocos, 'My Planner'); })
      .catch(e => Alert.alert(t('Não foi possível'), String(e?.message ?? e)));
  },
});

/** Título da seção e tabela, só se houver linhas. */
export function secaoPdf(titulo: string, colunas: string[], linhas: string[][], larguras?: number[]): BlocoPdf[] {
  return linhas.length ? [{ t: 'sub', texto: titulo }, { t: 'tabela', colunas, linhas, larguras }] : [];
}

/** Dados da ficha, um "Rótulo: valor" por linha, sem os vazios. */
export function dadosPdf(pares: [string, unknown][]): BlocoPdf[] {
  const linhas = pares.filter(([, v]) => v != null && v !== '' && v !== false).map(([r, v]) => `${r}: ${String(v)}`);
  return linhas.length ? [{ t: 'par', texto: linhas.join('\n'), tam: 10 }, { t: 'linha' }] : [];
}

/** Ordena pela data (vazias no fim). */
export const porDataPdf = <T extends { c: Record<string, any> }>(l: T[], k = 'data', desc = false) =>
  [...l].sort((a, b) => { const x = String(a.c[k] || ''), y = String(b.c[k] || ''); if (!x || !y) return x ? -1 : y ? 1 : 0; return desc ? y.localeCompare(x) : x.localeCompare(y); });
